import CRUDService from "../../services/base/CRUDService";

export default class IntegrationConfigurationService extends CRUDService {

  static ALL_URL = "integration/v1/integration-configurations/";

  getBaseURL() {
    return IntegrationConfigurationService.ALL_URL;
  }

  findTypes() {
    return this.getHttpRequest().get(`${IntegrationConfigurationService.ALL_URL}types`)
  }
}



// WEBPACK FOOTER //
// ./src/integration/configuration/IntegrationConfigurationService.js